import { useCmsClientContext } from '../../../utils/cmsPageContext';
import { getClientTranslations } from '../../../utils/translations/getClientTranslations';
import { TRANSLATIONS } from '../i18n';

type LoanRateCellProps = {
  rate: string;
  effectiveRate: string;
};

/**
 * SingSaver's interest cell in a Personal Loan Quick Answer (CMS-1928 R3): the
 * ANNUAL_RATE value with the engine's EIR stacked under it, in one column.
 * Type and spacing are the prototype's, which the ticket defers to.
 */
export const LoanRateCell = ({ rate, effectiveRate }: LoanRateCellProps) => {
  const context = useCmsClientContext();
  const staticText = getClientTranslations(TRANSLATIONS, context);

  return (
    <span className="flex flex-col gap-spacing/gap/soft-4px">
      <span
        title={rate}
        className="truncate font-font-weight/table-cell-primary text-font-size/table-cell-primary leading-line-height/table-cell-primary text-text/primary"
      >
        {rate}
      </span>
      <span className="truncate font-font-weight/table-cell-normal text-font-size/table-cell leading-line-height/table-cell text-text/secondary-lighter">
        {staticText.eir} {effectiveRate}
      </span>
    </span>
  );
};
